import { Injectable } from '@angular/core';
import { ConfigService } from '../../config/config.service';
import AccountService from '../../../../old-crazy-web-frontend/src/app/accounts/accounts.service';

@Injectable()
export class Ng1AccountService {
  private accountService: AccountService;

  constructor(private configService: ConfigService) {
    this.accountService = configService.getValue('AccountsService');
  }

  choose(account) {
    this.accountService.setAccount(account, null);
  }

  setAccountsLength(length) {
    this.accountService.setAccountsLength(length);
  }
}
